'use strict';

require('./ContextMenuCustom.scss');
const React = require('react'),
    Menu = require('material-ui/lib/menus/menu'),
    MenuItem = require('material-ui/lib/menus/menu-item'),
    MenuDivider = require('material-ui/lib/menus/menu-divider'),
    { map } = require('lodash/collection'),
    FontIcon = require('material-ui/lib/font-icon'),
    PopupUtils = require('utils/PopupUtils');

const CustomContextMenu = React.createClass({displayName: "CustomContextMenu",

    componentDidMount() {
        document.addEventListener('click', this.onClickOutSide);
    },

    componentWillUnmount() {
        document.removeEventListener('click', this.onClickOutSide, false);
    },

    getInitialState() {
        return {
            isVisible: false,
            isNewMode: false
        };
    },

    componentDidUpdate() {
        const targetEl = this.refs.targetEl.getDOMNode();
        const menuEl = this.refs.contextMenuEl.getDOMNode();
        PopupUtils.setPosition(menuEl, targetEl, ['bottom', 'top'], ['left', 'right']);
    },

    onClickOutSide() {
        this.close();
    },

    show(x, y, displayText, textDisplaySubtitleDate, menuItems, isNewMode) {
        this.setState(prevState => {
            return {
                isVisible: !prevState.isVisible,
                left: x,
                top: y,
                displayText,
                textDisplaySubtitleDate,
                menuItems,
                isNewMode
            };
        });
    },

    close() {
        this.setState({
            isVisible: false
        });
    },

    render() {
        const {isNewMode, menuItems, displayText, isVisible, top, left, textDisplaySubtitleDate} = this.state;
        const meuItemsEl = map(menuItems, menuItem => {
            if (menuItem.isDivider) {
                return (React.createElement(MenuDivider, null));
            }
            const fontIcon = (React.createElement(FontIcon, {className: "material-icons"}, menuItem.icon));
            return (
                React.createElement(MenuItem, {
                    className: "context-menu icon", 
                    leftIcon: fontIcon, 
                    primaryText: menuItem.text, 
                    onClick: menuItem.onClick}
                )
            );
        });

        return (
            React.createElement("div", {className: "menu-container", ref: "targetEl", style: {
                display: isVisible ? 'block' : 'none',
                position: 'absolute',
                top: top + 'px',
                left: left + 'px',
                minWidth: '320px !important',
                overflow: 'hidden !important'
            }}, 
                React.createElement(Menu, {width: 320, desktop: true, 
                      ref: "contextMenuEl", 
                      "data-is-new-mode": isNewMode, 
                      "data-display-first-line": displayText, 
                      "data-display-second-line": textDisplaySubtitleDate, 
                      "data-menu-context": "right-click-context-menu", 
                      style: {
                          display: isVisible ? 'block' : 'none',
                          position: 'fixed',
                          top: top + 'px',
                          left: left + 'px',
                          minWidth: '320px !important'
                      }}, 

                    meuItemsEl 
                )
            )
        );

    }
});


module.exports = CustomContextMenu;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/ContextMenuCustom/ContextMenuCustom.js
 **/